<app-breadcrumb [title]="'Разпределяне на Приходи'" [items]="['Каса']" [active_item]="'Разпределяне на Приходи'"></app-breadcrumb>
<div style="display: flex; justify-content: end; margin-bottom:10px">
  <button [disabled]="!selectedService" type="button" class="btn btn-success" (click)="checkDetails()">Детайли</button>
</div>
<ng-container *ngIf="isLoaded">
  <table class="table table-hover">
    <thead>
      <tr>
        <th scope="col">ИБАН</th>
        <th scope="col">Статус</th>
        <th scope="col">Обща Стойност</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let service of taxSettlement" [ngClass]="!isSelected(service)?'':'selected-cell'" (click)="onSelected(service)">
        <td>{{getIBAN(service)}}</td>
        <td>{{getStatus(service)}}</td>
        <td>{{service.totalSum}} лв</td>
      </tr>

    </tbody>
  </table>
</ng-container>
<ng-container *ngIf="!isLoaded">
  <div style="text-align: center;">
    <div class="spinner-grow spinner-grow-sm" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <div class="spinner-grow" style="width: 30px; height: 30px;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <div class="spinner-grow" style="width: 40px; height: 40px;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <div class="spinner-grow" style="width: 50px; height: 50px;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</ng-container>
